module.exports = __webpack_public_path__ + "static/media/hotlistIcon-selected.ac93f2e1.svg";